<template lang="pug">
  div
    app-editor-texto(
      :value="content"
      v-model="content"
      @onTextChange="onTextChange"
      )
</template>

<script>
import AppEditorTexto from '@/components/AppEditorTexto'

export default {
  components: {
    AppEditorTexto
  },

  props: {
    conteudo: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      content: ''
    }
  },

  watch: {
    conteudo: {
      handler (val, oldVal) {
        if (val !== oldVal) {
          this.content = val
        }
      }
    }
  },

  methods: {
    onTextChange (val) {
      this.content = val
      this.$emit('onTextChange', val)
    }
  },

  async mounted () {
    this.$emit('getRawDocument')
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/AppPDFEditor.vue